<template>
  <div
    :style="
      isActiveMenus !== false || activeAlert.status !== false
        ? 'overflow-y:hidden;'
        : ''
    "
    id="app"
  >
    <transition name="fade" mode="out-in">
      <modal v-if="isActiveMenus" class="z-4000" />
    </transition>
    <transition name="fade" mode="out-in">
      <alerts
        v-if="activeAlert && activeAlert.status"
        :activeAlert="activeAlert"
      />
    </transition>
    <nav-bar
      id="navbar"
      ref="navbar"
      :navHeight="{ marginTop: navHeight + 'px' }"
    />
    <transition name="fade" mode="out-in">
      <router-view
        id="content"
        class="w-100 h-100"
        :navHeight="{ paddingTop: navHeight + 'px' }"
      />
    </transition>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex"
import NavBar from "@/components/UI/Partials/NavBar.vue"
import Alerts from "@/components/UI/Partials/Alerts.vue"
import Modal from "@/components/UI/Partials/Modal.vue"
export default {
  data() {
    return {
      //navHeight: 50,
      isMounted: false,
    }
  },
  metaInfo() {
    return {
      title: process.env.npm_package_name || "",

      meta: [
        {
          name: "description",
          content:
            "Panel de administración de perfiles de Prepagos69 | Conoce los mejores clientes de forma rápida y sencilla",
        },
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        { name: "site_name", content: "Prepagos 69" },
        { name: "og:site_name", content: "Prepagos 69" },
        { name: "theme-color", content: "#000000" },
      ],
      link: [],
      script: [],
    }
  },
  components: { NavBar, Alerts, Modal },
  methods: {
    ...mapActions([
      "INIT_APP",
      "FETCH_countries",
      "SET_NAVSTYLE",
      "SET_ALERTSTYLE",
      "CHANGE_ALERT",
      "FETCH_activeObjects",
    ]),
  },
  mounted() {
    this.INIT_APP().then(state => {
      if (state == true) {
        if (this.user && this.user.profiles.length == 0) {
          /* this.$router.push({
            path: "account",
            query: { welcome: true, step: 0 },
          }) */
        } else {
          const kProfile = this.user.profiles.filter(profile => {
            return profile._id == this.user.kProfile
          })
          console.log("GETTED KPROFILE", kProfile[0])
          if (kProfile[0].status == "pending") {
            this.CHANGE_ALERT(true)
          } else {
            this.CHANGE_ALERT(false)
            this.SET_ALERTSTYLE({
              ...this.alertStyle,
              height: "0px",
            })
          }
        }
        this.SET_NAVSTYLE({
          ...this.navStyle,
          backgroundColor: this.colorScheme.accent,
          color: "white",
          boxShadow: "none",
        })
      }
    })
    this.FETCH_countries()
    this.FETCH_activeObjects()
  },
  computed: {
    ...mapGetters([
      "navStyle",
      "alertStyle",
      "colorScheme",
      "navStyle",
      "user",
      "activeAlert",
      "modalPlaceHolder",
      "activeMenus",
      "kCity",
      "kCategory",
      "kProfile",
      "alert",
    ]),
    navHeight() {
      if (this.alert && this.$route.path == "/") {
        return (
          parseInt(this.navStyle.height, 10) +
          parseInt(this.alertStyle.height, 10)
        )
      } else {
        return parseInt(this.navStyle.height, 10)
      }
    },
    isActiveMenus() {
      return Object.values(this.activeMenus).indexOf(true) >= 0
    },
  },
  /* watch: {
    isActiveMenus: function() {
      console.log("CAMBIARON SELECCION COMO FOTO", this.isMediaSelected)
      if (this.isActiveMenus) {
        document.documentElement.style.overflow = "hidden"
      } else {
        document.documentElement.style.overflow = "auto"
      }
    },
    activeAlert: function() {
      console.log("CAMBIARON SELECCION COMO FOTO", this.activeAlert)
      if (this.activeAlert) {
        document.documentElement.style.overflow = "hidden"
      } else {
        document.documentElement.style.overflow = "auto"
      }
    },
  }, */
}
</script>

<style lang="scss">
#app {
}
</style>
